/* Zvučni efekti sintetizovani u pregledaču (Web Audio) — bez zvučnih fajlova. Pregledač dozvoljava zvuk tek posle
   prve interakcije korisnika (klik/taster), pa se kontekst budi tada. */

let ctx = null;
export const zvukKontekst = () => {
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
    }
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
};

const ton = (c, { tip = 'sine', f, f2, od = 0, traje = 0.3, jacina = 0.3, izlaz }) => {
    const o = c.createOscillator(), g = c.createGain();
    o.type = tip;
    const t0 = c.currentTime + od;
    o.frequency.setValueAtTime(f, t0);
    if (f2) o.frequency.linearRampToValueAtTime(f2, t0 + traje);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(jacina, t0 + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + traje);
    o.connect(g).connect(izlaz);
    o.start(t0);
    o.stop(t0 + traje + 0.05);
};

const EFEKTI = {
    zvono: (c, iz) => { ton(c, { f: 880, traje: 1.2, izlaz: iz }); ton(c, { f: 1320, traje: 0.9, jacina: 0.15, izlaz: iz }); ton(c, { f: 660, od: 0.35, traje: 1.2, izlaz: iz }); },
    truba: (c, iz) => [523, 659, 784, 1046].forEach((f, i) => ton(c, { tip: 'sawtooth', f, od: i * 0.16, traje: i === 3 ? 0.6 : 0.18, jacina: 0.18, izlaz: iz })),
    sirena: (c, iz) => { ton(c, { f: 600, f2: 1000, traje: 0.6, jacina: 0.2, izlaz: iz }); ton(c, { f: 1000, f2: 600, od: 0.6, traje: 0.6, jacina: 0.2, izlaz: iz }); },
    bip: (c, iz) => { ton(c, { tip: 'square', f: 1000, traje: 0.12, jacina: 0.12, izlaz: iz }); ton(c, { tip: 'square', f: 1000, od: 0.2, traje: 0.12, jacina: 0.12, izlaz: iz }); },
    kuc: (c, iz) => [0, 0.22, 0.44].forEach((od) => ton(c, { tip: 'triangle', f: 140, f2: 70, od, traje: 0.12, jacina: 0.5, izlaz: iz })),
};

/** pusti efekat (jacina 0–100) */
export function pustiEfekat(naziv, jacina = 40) {
    const c = zvukKontekst();
    if (!c || !EFEKTI[naziv]) return;
    const g = c.createGain();
    g.gain.value = Math.min(0.7, jacina / 100);
    g.connect(c.destination);
    EFEKTI[naziv](c, g);
}

export const NAZIVI_EFEKATA = [
    { label: 'Zvono', value: 'zvono' },
    { label: 'Truba (fanfara)', value: 'truba' },
    { label: 'Sirena', value: 'sirena' },
    { label: 'Bip-bip', value: 'bip' },
    { label: 'Kucanje', value: 'kuc' },
];
